/**
 * Browser download utility for SDK binary responses.
 */

/**
 * Trigger a browser file download from a Blob.
 *
 * @example
 * ```ts
 * import { downloadBlob } from '@spaceinvoices/js-sdk';
 *
 * const blob = await sdk.invoices.renderPdf(invoiceId);
 * downloadBlob(blob, 'Invoice 123.pdf');
 * ```
 */
export function downloadBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
